<script>
import SelecForm from '@/components/selecForm.vue';
import common_data from "@/util/common_data.js";
import config from "@/util/config.js";
import TableCommon from "@/components/table.vue";
import cookies from 'vue-cookies';

export default {
  components: {
    SelecForm,
    TableCommon,
  },
  data() {
    return {
      config,
      form_search_style: common_data.form_search_style,
      form: [
        {
          key: "invoice_no",
          label: "税务发票号",
          type: "input",
          d_value: "",
          placeholder: "请输入税务发票号",
        },
        {
          key: "system_invoice_no",
          label: "系统发票号",
          type: "input",
          d_value: "",
          placeholder: "请输入税务发票号",
        },
        {
          key: "order_no",
          label: "关联订单号",
          type: "input",
          d_value: "",
          placeholder: "请输入关联订单号",
        },
        {
          key: "invoice_title",
          label: "购方名称",
          type: "input",
          d_value: "",
          placeholder: "请输入购方名称",
        },
        {
          key: "status",
          label: "发票状态",
          type: "select",
          list: [{ id: -2, name: '全部' }, ...common_data.invoice_status],
          d_value: -2,
        },
        {
          key: "invoice_type",
          label: "发票类型",
          type: "select",
          list: [{ id: 0, name: '全部' }, ...common_data.invoice_type],
          d_value: 0,
        },
        {
          key: "invoice_method",
          label: "开票方式",
          type: "select",
          list: [{ id: 0, name: '全部' }, ...common_data.invoice_method],
          d_value: 0,
        },
        {
          key: "amount",
          label: "开票金额",
          type: "number_range",
          d_value: ['', ''],
          placeholder: ['最小金额', '最大金额'],
        },
        {
          key: "invoice_time",
          label: "申请时间",
          type: "datetimerange",
        },
      ],
      table_config: [
        { key: "is_choose", type: "slot", header: true, width: "70px", fixed: "left" },
        { key: "system_invoice_no", label: "系统发票号", type: "text", nowrap: true, width: '200px' },
        { key: "invoice_no", label: "税务发票号", type: "text", nowrap: true, width: '200px' },
        { key: "order_no", label: "关联订单号", type: "text", nowrap: true, width: '200px' },
        { key: "create_time", label: "开票时间", type: "time", nowrap: true, width: '150px' },
        { key: "invoice_method", label: "开票方式", type: "slot", nowrap: true, width: '150px' },
        { key: "invoice_title", label: "购方名称", type: "text", nowrap: true, width: '200px' },
        { key: "voucher_issuing_entity", label: "开票主体", type: "text", nowrap: true, width: '200px' },
        { key: "order_price", label: "不含税金额", type: "text", nowrap: true, width: '100px' },
        { key: "rake", label: "税点", type: "slot", nowrap: true, width: '100px' },
        { key: "tax_price", label: "税费", type: "text", nowrap: true, width: '100px' },
        { key: "invoice_price", label: "开票金额", type: "text", nowrap: true },
        { key: "invoice_type", label: "发票类型", type: "slot", nowrap: true, width: '150px' },
        { key: "invoice_title_type", label: "抬头类型", type: "slot", nowrap: true },
        { key: "status", label: "发票状态", type: "slot", nowrap: true },
        { key: "electronic_invoice_pdf", label: "发票文件", type: "slot", nowrap: true, width: '150px' },
        { key: "cz", label: "操作", type: "slot", fixed: 'right', width: '150px' },
      ],
      is_choose_all: false,
      data_config: {
        page: 1,
        rows: 10,
        list: [],
        total_number: 0
      },
      that_data: {},
      invoice_examine_dialog: {
        show: false,
        status: '',
        invoice_no: '',
        system_remark: '',
        reason: '',
        electronic_invoice_pdf: [],
      },
      examine_rules: {
        status: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    };
  },
  computed: {
    invoice_method_hash() {
      let hash = {};
      common_data.invoice_method.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
    invoice_type_hash() {
      let hash = {};
      common_data.invoice_type.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
    invoice_title_type_hash() {
      let hash = {};
      common_data.invoice_title_type.forEach(item => {
        hash[`${item.id}`] = item.name;
      })
      return hash;
    },
    invoice_status_hash() {
      let hash = {};
      common_data.invoice_status.forEach(item => {
        hash[item.id] = item.name;
      })
      return hash;
    },
    token() {
      return cookies.get('token');
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    handleSelect() {
      this.data_config.page = 1
      this.getDataList()
    },
    changeAllChoose() {
      this.data_config.list.forEach(item => {
        item.is_choose = this.is_choose_all
      })
    },
    changeChoose(item) {
      let choose_number = this.data_config.list.filter(item => item.is_choose).length;
      this.is_choose_all = choose_number == this.data_config.list.length
    },
    getDataList() {
      let obj = {
        page: this.data_config.page,
        rows: this.data_config.rows,
      };
      if (this.$refs.select_form) obj = { ...obj, ...this.$refs.select_form.deal() };
      this.$axios.post(this.$api.order.invoiceList, obj)
        .then(res => {
          if (res.code == 0) {
            res.result.list.forEach(item => {
              item.is_choose = false;
            })
            this.data_config.list = res.result.list;
            this.data_config.total_number = res.result.total_number;
          }
        })
    },
    tableDataConfigChange(val, status) {
      if (status == 0) {
        this.data_config.rows = val;
        this.data_config.page = 1;
      } else {
        this.data_config.page = val;
      }
      this.getDataList();
    },
    invoiceExamine(data) {
      this.that_data = data
      this.invoice_examine_dialog.status = ''
      this.invoice_examine_dialog.reason = ''
      this.invoice_examine_dialog.electronic_invoice_pdf = []
      this.invoice_examine_dialog.invoice_no = ''
      this.invoice_examine_dialog.show = true
    },
    getPdfList(response, file) {
      this.invoice_examine_dialog.electronic_invoice_pdf.push({
        path: response.result.path,
        name: file.name
      })
    },
    handleRemovePdf(file) {
      this.invoice_examine_dialog.electronic_invoice_pdf = this.invoice_examine_dialog.electronic_invoice_pdf.filter(item => item.name != file.name)
    },
    handlePreviewPdf(file) {
      window.open(file.response.result.path)
    },
    handleStatusChange() {
      if (this.invoice_examine_dialog.status == -1) {
        this.examine_rules.system_remark = [{ required: true, message: '请输入开票失败原因', trigger: 'blur' }]
      }
      if (this.invoice_examine_dialog.status == 2) {
        this.examine_rules.invoice_no = [{ required: true, message: '请输入发票号', trigger: 'blur' }]
        this.examine_rules.electronic_invoice_pdf = [{ required: true, message: '请上传发票文件', trigger: 'change' }, { validator: this.checkPdfList, message: '请上传发票文件', trigger: 'change' }]
      }
      this.$nextTick(() => {
        this.$refs.examine_form.clearValidate()
      })
    },
    checkPdfList(value, rule, callback) {
      if (value.length == 0) {
        callback(new Error('请上传发票文件'))
      } else {
        callback()
      }
    },
    checkUploadFile(file) {
      let max_size = 1024 * 1024 * 5
      if (max_size < file.size) {
        this.$message({
          message: '单个发票文件大小不能超过5MB',
          type: 'error',
        })
        return false
      }
    },
    handleDialogClose() {
      this.$refs.examine_form.resetFields()
    },
    confirmHandleSubmit() {
      this.$refs.examine_form.validate((valid) => {
        if (valid) {
          let url = this.$api.invoice.editStatus
          let obj = {
            id: this.that_data.id,
            status: this.invoice_examine_dialog.status,
          }
          if (this.invoice_examine_dialog.reason) {
            obj.reason = this.invoice_examine_dialog.reason
          }
          if (this.invoice_examine_dialog.status == -1) {
            obj.system_remark = this.invoice_examine_dialog.system_remark
          }
          if (this.invoice_examine_dialog.status == 2) {
            obj.invoice_no = this.invoice_examine_dialog.invoice_no
            obj.electronic_invoice_pdf = this.invoice_examine_dialog.electronic_invoice_pdf
          }
          this.$axios.post(url, obj)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '审核成功',
                  type: 'success',
                })
                this.$axios.post(this.$api.invoice.sendEmail, { id: this.that_data.id })
                this.getDataList()
                this.invoice_examine_dialog.show = false
              }
            })
        }
      })
    }
  },
}
</script>
<template>
  <el-main>
    <SelecForm @search="handleSelect" labelWidth="130px" :form="form" :form_style="form_search_style" ref="select_form">
    </SelecForm>

    <div class="btns_rows"></div>

    <TableCommon :data="data_config.list" :table_config="table_config">
      <template #h_is_choose>
        <el-checkbox v-model="is_choose_all" @change="changeAllChoose"></el-checkbox>
      </template>
      <template #is_choose="{ row }">
        <el-checkbox v-model="row.is_choose" @change="() => changeChoose(row)"></el-checkbox>
      </template>
      <template #invoice_method="{ row }">
        {{ invoice_method_hash[row.invoice_method] }}
      </template>
      <template #rake="{ row }">
        {{ Number(row.rake) * 100 }}%
      </template>
      <template #invoice_type="{ row }">
        {{ invoice_type_hash[row.invoice_type] }}
      </template>
      <template #invoice_title_type="{ row }">
        {{ invoice_title_type_hash[`${row.title_type}`] }}
      </template>
      <template #status="{ row }">
        {{ invoice_status_hash[row.status] }}
      </template>
      <template #electronic_invoice_pdf="{ row }">
        <div class="pdf_list">
          <el-tooltip v-for="(pdf,index) in row.electronic_invoice_pdfs" :key="index" class="item"
            :content="pdf.name" placement="top">
            <el-link :href="pdf.path" target="_blank">{{pdf.name}}</el-link>
          </el-tooltip>
        </div>
      </template>
      <template #cz="{ row }">
        <el-button type="text" size="mini" @click="$router.push('/order/invoiceDetail/' + row.id)">查看</el-button>
        <!-- <el-button type="text" size="mini" v-if="row.status == 0 || row.status == 1" @click="invoiceExamine(row)">审核</el-button> -->
      </template>
    </TableCommon>

    <Paging :total="data_config.total_number" :page="data_config.page" :pageNum="data_config.rows"
      @updatePageNum="tableDataConfigChange"></Paging>

    <el-dialog title="发票审核" :visible.sync="invoice_examine_dialog.show" width="500px" @close="handleDialogClose">
      <el-form :model="invoice_examine_dialog" label-width="120px" ref="examine_form" class="examine_form"
        :rules="examine_rules">
        <el-form-item label="发票审核：" prop="status">
          <el-select v-model="invoice_examine_dialog.status" placeholder="请选择" @change="handleStatusChange">
            <el-option label="审核驳回" :value="-1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失败原因：" v-if="invoice_examine_dialog.status == -1" prop="system_remark">
          <el-input v-model="invoice_examine_dialog.system_remark" placeholder="请输入开票失败原因"></el-input>
        </el-form-item>
        <el-form-item label="发票号：" v-if="invoice_examine_dialog.status == 2" prop="invoice_no">
          <el-input v-model="invoice_examine_dialog.invoice_no" placeholder="请输入发票号"></el-input>
        </el-form-item>
        <el-form-item label="发票文件：" v-if="invoice_examine_dialog.status == 2" prop="electronic_invoice_pdf">
          <el-upload accept=".pdf" :headers="{'access-token':token}" class="upload-demo"
            :action="config.baseurl + '/admin' + $api.user.addFiles" multiple :limit="3" name="files"
            :on-success="getPdfList" :on-remove="handleRemovePdf" :on-preview="handlePreviewPdf"
            :before-upload="checkUploadFile">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">限制3个发票文件(.pdf)上传</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="invoice_examine_dialog.reason" type="textarea" :rows="5" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoice_examine_dialog.show = false">取 消</el-button>
        <el-button type="primary" @click="confirmHandleSubmit">确认</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<style lang="less" scoped>
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
  .btns_rows {
    padding: 10px 0;
  }
  .pdf_list {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    width: 100%;
    .el-link {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      /deep/ .el-link--inner {
        width: 100%;
      }
    }
  }
}
.examine_form {
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>